import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { load } from 'recaptcha-v3';
import { gtag } from 'ga-gtag';
import getUrlPath from '../../utils/getUrlPath';
import { getCookie } from './cookies';
import { purgePIIFromLocalStorage } from './util';
export var ANON = "test-demo-anon-user";
export var identifyE2E = function identifyE2E(host) {
  var dev = /^localhost/i;
  var staging = /^segment\.build$/i;

  if ((dev.test(host) || staging.test(host)) && window.Cypress) {
    return true;
  }

  return false;
};
export var getBackendHost = function getBackendHost(host, protocol) {
  var dev = /^localhost/i;
  var staging = /^segment\.build$/i;
  var production = /^segment\.com$/i;
  var cdpweek = /^cdpweek\.com$/i;
  var subdomain = /^([a-zA-Z0-9]+)\.segment\.(build|com)$/;

  if (dev.test(host)) {
    return "".concat(protocol, "//localhost:3001");
  }

  if (cdpweek.test(host)) {
    return "https://segment.com";
  }

  if (staging.test(host) || production.test(host) || subdomain.test(host)) {
    return "".concat(protocol, "//").concat(host);
  }

  if (/^cdpweek/i.test(host)) {
    return "".concat(protocol, "//segment.com");
  }

  return "https://segment.build";
};
/**
 * Helper function to check parsable strings
 */

var isParsable = function isParsable(value) {
  if (!value) return false;

  try {
    JSON.parse(value);
  } catch (e) {
    return false;
  }

  return true;
};
/**
 * Get Client ID from google analytics
 * @returns {string} clientId
 */


var getClientIdFromGA = function getClientIdFromGA() {
  var _ga = typeof ga !== "undefined" && ga || function (arg) {
    arg({
      get: function get() {
        return "";
      }
    });
  };

  var clientId;

  _ga(function (tracker) {
    clientId = tracker.get("clientId");
  });

  return clientId;
};
/**
 * Adds global tracking props to a given properties object
 * @param {Object} props
 * @returns {Object} updated props
 */


export var addGlobalTrackingProps = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(type, props) {
    var tempProps, cookies, propertyName, cookieName, cookieValue, getGa4SessionId, getGa4ClientId, sessionData;
    return _regeneratorRuntime.wrap(function _callee$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            tempProps = _objectSpread({}, props); // Map property name -> cookie name

            cookies = {
              entryCampaign: "seg_first_utm",
              fbp: "_fbp",
              fbc: "_fbc",
              gclid: "gclid"
            };

            for (propertyName in cookies) {
              cookieName = cookies[propertyName];
              cookieValue = getCookie(cookieName); // Add all existing cookied properties

              if (cookieName && typeof cookieValue !== "undefined") {
                if (propertyName === "entryCampaign") {
                  tempProps[propertyName] = convertUtmToCampaign(cookieValue || "null");
                } else if (isParsable(cookieValue)) {
                  tempProps[propertyName] = JSON.parse(cookieValue || "null");
                } else {
                  tempProps[propertyName] = cookieValue;
                }
              }
            }

            if (type === "track" && !tempProps.actionSource) {
              tempProps.actionSource = "website";
            }

            getGa4SessionId = new Promise(function (resolve) {
              gtag("get", "G-xxxxxxxxxx", "session_id", resolve);
            });
            getGa4ClientId = new Promise(function (resolve) {
              gtag("get", "G-xxxxxxxxxx", "client_id", resolve);
            });
            _context2.prev = 6;
            _context2.next = 9;
            return Promise.all([getGa4ClientId, getGa4SessionId]);

          case 9:
            sessionData = _context2.sent;
            tempProps.gaClientId = sessionData[0] || "null";
            tempProps.gaSessionId = sessionData[1] || "null";
            _context2.next = 17;
            break;

          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2["catch"](6);
            console.log(_context2.t0);

          case 17:
            return _context2.abrupt("return", tempProps);

          case 18:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee, null, [[6, 14]]);
  }));

  return function addGlobalTrackingProps(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * Add global data to context.
 * @param {string} type (track or identify)
 * @param {Object} props
 * @param {Object} context
 * @returns {Object} mappedDemoRequestData
 */

export var addGlobalContext = function addGlobalContext(type, _ref2) {
  var _ref2$props = _ref2.props,
      props = _ref2$props === void 0 ? {} : _ref2$props,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? {} : _ref2$context;

  var _context = _objectSpread({}, context);

  if (type === "track") {
    _context.traits = {
      email: props.email
    };
  }

  return _context;
};
/**
 * Converts a utm string to a Segment campaign object (https://segment.com/docs/connections/spec/common/#context)
 * @param {String} utmString
 * @returns {Object} campaign object
 */

var convertUtmToCampaign = function convertUtmToCampaign(utmString) {
  var utms = JSON.parse(utmString);
  var campaign = {};
  Object.keys(utms).forEach(function (key) {
    var newKey = key.replace("utm_", ""); // If the key is "utm_campaign", we map it to "name"

    if (newKey === "campaign") newKey = "name"; // Set new campaign context

    campaign[newKey] = utms[key];
  });
  return campaign;
};
/**
 * Return parsed device from User Agent and map to context device object.
 * @returns {Object} context device object
 */


var getDeviceContext = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", import("ua-parser-js").then(function (module) {
              var uaParser = module["default"](navigator.userAgent);
              var device = uaParser.device;
              if (!device.type) return {
                type: "desktop"
              };
              return {
                type: device.type,
                model: device.model,
                manufacturer: device.vendor
              };
            }));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee2);
  }));

  return function getDeviceContext() {
    return _ref3.apply(this, arguments);
  };
}();
/**
 * Add page context manually to be consistent across front and back-end events
 *   - If we do not manually set these, they will not exist in back-end events! This is just how it works.
 * @param {Object} context context object to be updated if applicable
 * @returns {Object} updated context
 */


var getUpdatedContext = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var context,
        newContext,
        utmCookie,
        _args3 = arguments;
    return _regeneratorRuntime.wrap(function _callee3$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            context = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {};
            newContext = context; // Set up page context

            newContext.page = {
              path: document.location.pathname,
              referrer: document.referrer,
              referrerPath: getUrlPath(document.referrer),
              search: document.location.search,
              title: document.title,
              url: document.location.href
            }; // Set device to context

            _context4.prev = 3;
            _context4.next = 6;
            return getDeviceContext();

          case 6:
            newContext.device = _context4.sent;
            _context4.next = 12;
            break;

          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4["catch"](3);
            console.error(_context4.t0);

          case 12:
            // If UTM is present, set up current campaign context
            utmCookie = getCookie("seg_attr_utm");

            if (utmCookie) {
              if (!newContext.campaign) newContext.campaign = {};
              newContext.campaign = convertUtmToCampaign(utmCookie);
            }

            return _context4.abrupt("return", newContext);

          case 15:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee3, null, [[3, 9]]);
  }));

  return function getUpdatedContext() {
    return _ref4.apply(this, arguments);
  };
}();
/**
 * Gets the tracking preference values from the `tracking-preferences` cookie.
 * @returns {TrackingPreferences}
 */


export var getTrackingPreferences = function getTrackingPreferences() {
  var userTrackingPreferences = getCookie("tracking-preferences");

  if (!userTrackingPreferences) {
    return;
  }

  var parsedUserTrackingPreferences = JSON.parse(decodeURIComponent(userTrackingPreferences));
  return parsedUserTrackingPreferences;
};
/**
 * Overrides tracking preferences for users who agree to Segment's privacy policy
 * and provide consent while submitting a form.
 * @param {TrackingPreferences} initialTrackingPreferences
 * @returns {TrackingPreferences}
 */

export var overrideTrackingPreferences = function overrideTrackingPreferences(initialTrackingPreferences) {
  // Deep copy this object using JSON.stringify/JSON.parse
  var temporaryTrackingPreferences = JSON.parse(JSON.stringify(initialTrackingPreferences));
  var custom = temporaryTrackingPreferences.custom,
      destinations = temporaryTrackingPreferences.destinations; // Set destinations and custom tracking preferences to true

  Object.keys(destinations).forEach(function (key) {
    destinations[key] = true;
  });
  Object.keys(custom).forEach(function (key) {
    custom[key] = true;
  });
  return temporaryTrackingPreferences;
};
/**
 * Combination client-side and server-side identify call
 * @param {Object} traits
 * @param {boolean} overrideConsent
 * @returns {boolean}
 */

export var identify = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var traits,
        overrideConsent,
        initialTrackingPreferences,
        temporaryTrackingPreferences,
        temporaryAllowedDestinations,
        context,
        _args4 = arguments;
    return _regeneratorRuntime.wrap(function _callee4$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            traits = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
            overrideConsent = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : false;
            _context5.next = 4;
            return addGlobalTrackingProps("identify", traits);

          case 4:
            traits = _context5.sent;

            if (traits.password) {
              delete traits.password;
            }

            initialTrackingPreferences = getTrackingPreferences();

            // Override tracking preferences
            if (overrideConsent && initialTrackingPreferences) {
              temporaryTrackingPreferences = overrideTrackingPreferences(initialTrackingPreferences);
            }

            if (window.analytics && identifyE2E(window.location.host)) {
              window.analytics.setAnonymousId(ANON);
            } // Client-side identify call


            if (window.analytics) {
              window.analytics.identify(traits);
            } // Now we prepare to pass the overridden destinations directly to the back end


            // Override tracking preferences
            if (temporaryTrackingPreferences) temporaryAllowedDestinations = temporaryTrackingPreferences.destinations; // Server-side identify call through `segment-site-backend`

            _context5.prev = 11;
            _context5.next = 14;
            return getUpdatedContext();

          case 14:
            context = _context5.sent;
            _context5.next = 17;
            return fetch("".concat(getBackendHost(window.location.host, window.location.protocol), "/backend/identify"), {
              method: "POST",
              headers: {
                'Content-Type': "application/json"
              },
              body: JSON.stringify({
                context: context,
                traits: traits,
                integrationsOverride: temporaryAllowedDestinations
              })
            });

          case 17:
            _context5.next = 23;
            break;

          case 19:
            _context5.prev = 19;
            _context5.t0 = _context5["catch"](11);
            console.error(_context5.t0);
            throw new Error("Identify Error");

          case 23:
            return _context5.abrupt("return", true);

          case 24:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee4, null, [[11, 19]]);
  }));

  return function identify() {
    return _ref5.apply(this, arguments);
  };
}();

/**
 * Combination client-side and server-side track call
 * @param {string} event
 * @param {Object} properties
 * @param {boolean} overrideConsent
 * @returns {Promise<boolean>}
 */
export var track = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(event) {
    var properties,
        overrideConsent,
        trackingMethod,
        payload,
        fireClientSideTracking,
        fireServerSideTracking,
        initialTrackingPreferences,
        temporaryTrackingPreferences,
        temporaryAllowedDestinations,
        _args5 = arguments;
    return _regeneratorRuntime.wrap(function _callee5$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            properties = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
            overrideConsent = _args5.length > 2 && _args5[2] !== undefined ? _args5[2] : false;
            trackingMethod = _args5.length > 3 && _args5[3] !== undefined ? _args5[3] : "both";
            _context6.next = 5;
            return addGlobalTrackingProps("track", properties);

          case 5:
            _context6.t0 = _context6.sent;
            _context6.t1 = addGlobalContext;
            _context6.t2 = properties;
            _context6.next = 10;
            return getUpdatedContext();

          case 10:
            _context6.t3 = _context6.sent;
            _context6.t4 = {
              props: _context6.t2,
              context: _context6.t3
            };
            _context6.t5 = (0, _context6.t1)("track", _context6.t4);
            payload = {
              properties: _context6.t0,
              context: _context6.t5
            };
            fireClientSideTracking = Boolean(trackingMethod === "client" || trackingMethod === "both");
            fireServerSideTracking = Boolean(trackingMethod === "server" || trackingMethod === "both");
            initialTrackingPreferences = getTrackingPreferences();

            // Override tracking preferences
            if (overrideConsent && initialTrackingPreferences) {
              temporaryTrackingPreferences = overrideTrackingPreferences(initialTrackingPreferences);
            }

            if (window.analytics && identifyE2E(window.location.host)) {
              window.analytics.setAnonymousId(ANON);
            } // Client-side track call


            if (window.analytics && fireClientSideTracking) {
              window.analytics.track(event, payload.properties);
            } // Server-side track call


            if (!fireServerSideTracking) {
              _context6.next = 30;
              break;
            }

            // Now we prepare to pass the overridden destinations directly to the back end
            // Override tracking preferences
            if (temporaryTrackingPreferences) temporaryAllowedDestinations = temporaryTrackingPreferences.destinations; // Server-side track call through `segment-site-backend`

            _context6.prev = 22;
            _context6.next = 25;
            return fetch("".concat(getBackendHost(window.location.host, window.location.protocol), "/backend/events"), {
              method: "POST",
              headers: {
                'Content-Type': "application/json"
              },
              body: JSON.stringify({
                context: payload.context,
                event: event,
                properties: payload.properties,
                integrationsOverride: temporaryAllowedDestinations
              })
            });

          case 25:
            _context6.next = 30;
            break;

          case 27:
            _context6.prev = 27;
            _context6.t6 = _context6["catch"](22);
            console.error(_context6.t6);

          case 30:
            return _context6.abrupt("return", true);

          case 31:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee5, null, [[22, 27]]);
  }));

  return function track(_x3) {
    return _ref6.apply(this, arguments);
  };
}();
export var trackPage = function trackPage() {
  var bypass = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  if (!bypass) {
    window.addEventListener("load", function () {
      var _window$analytics;

      return (_window$analytics = window.analytics) === null || _window$analytics === void 0 ? void 0 : _window$analytics.page();
    });
  }
};
/**
 * Demo form custom onSubmit logic.
 * Submits lead request to `segment-site-backend` and fires demo form track event.
 * @param {Object} demoFormData
 */

export var createDemoLead = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(demoFormData) {
    var utms, firstRawURL, gclid, clientId, recaptchaClientKey, recaptcha, token, defaultDemoFormType, defaultLeadFormType, defaultDemoFormId, demoLeadData, demoTrackingData, utmData;
    return _regeneratorRuntime.wrap(function _callee7$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            // Populate vars to add to payloads.
            utms = getCookie("seg_attr_utm");
            firstRawURL = getCookie("seg_first_url");
            gclid = getCookie("gclid"); // Get the google analytics client id if present.

            clientId = getClientIdFromGA(); // Get recaptcha token for posting to `segment-site-backend`.
            // See https://developers.google.com/recaptcha/docs/v3 for more info.

            recaptchaClientKey = process.env.RECAPTCHA_GCP_CLIENT_KEY || "";
            _context8.next = 7;
            return load(recaptchaClientKey);

          case 7:
            recaptcha = _context8.sent;
            _context8.next = 10;
            return recaptcha.execute("form");

          case 10:
            token = _context8.sent;
            // Demo form defaults for tracking
            defaultDemoFormType = "website";
            defaultLeadFormType = "demo";
            defaultDemoFormId = "1136"; // Set up the lead endpoint payload.

            demoLeadData = {
              formId: demoFormData.customFormIdentifier ? demoFormData.customFormIdentifier : defaultDemoFormId,
              // Marketo form identifier.
              formType: defaultLeadFormType,
              // Human-readable text that describes the Segment website form - relied upon downstream.
              recaptchaToken: token,
              formFields: {
                name: demoFormData.name,
                email: demoFormData.email,
                phone: demoFormData.phone,
                company: demoFormData.company,
                firstRawURL: firstRawURL,
                clientId: clientId,
                gclid: gclid
              },
              twilioPhoneValid: demoFormData === null || demoFormData === void 0 ? void 0 : demoFormData.twilioPhoneValid,
              twilioPhoneErrors: demoFormData === null || demoFormData === void 0 ? void 0 : demoFormData.twilioPhoneErrors,
              callingCountryCode: demoFormData === null || demoFormData === void 0 ? void 0 : demoFormData.callingCountryCode,
              countryCode: demoFormData === null || demoFormData === void 0 ? void 0 : demoFormData.countryCode,
              phoneNumber: demoFormData === null || demoFormData === void 0 ? void 0 : demoFormData.phoneNumber,
              nationalFormat: demoFormData === null || demoFormData === void 0 ? void 0 : demoFormData.nationalFormat
            }; // Set up the tracking payload.

            demoTrackingData = {
              email: demoFormData.email,
              type: demoFormData.customTrackingType ? demoFormData.customTrackingType : defaultDemoFormType,
              url: window.location.href,
              actionSource: "website",
              clientId: clientId,
              // NOTE: server_message_id is formatted as snake case because downstream analytics depend on that format
              // eslint-disable-next-line camelcase
              server_message_id: demoFormData === null || demoFormData === void 0 ? void 0 : demoFormData.server_message_id,
              gclid: gclid,
              form: {
                id: demoFormData.customFormIdentifier ? demoFormData.customFormIdentifier : defaultDemoFormId,
                firstName: demoFormData.name.split(" ")[0],
                lastName: demoFormData.name.split(" ").slice(1).join(" "),
                email: demoFormData.email,
                phone: demoFormData.phone,
                company: demoFormData.company
              },
              twilioPhoneValid: demoFormData === null || demoFormData === void 0 ? void 0 : demoFormData.twilioPhoneValid,
              twilioPhoneErrors: demoFormData === null || demoFormData === void 0 ? void 0 : demoFormData.twilioPhoneErrors,
              callingCountryCode: demoFormData === null || demoFormData === void 0 ? void 0 : demoFormData.callingCountryCode,
              countryCode: demoFormData === null || demoFormData === void 0 ? void 0 : demoFormData.countryCode,
              phoneNumber: demoFormData === null || demoFormData === void 0 ? void 0 : demoFormData.phoneNumber,
              nationalFormat: demoFormData === null || demoFormData === void 0 ? void 0 : demoFormData.nationalFormat
            }; // If we have utm parameters, let's append them to the `demoLeadData` payload.

            if (utms && utms.length) {
              try {
                utmData = JSON.parse(utms);
                demoLeadData = _objectSpread(_objectSpread({}, demoLeadData), utmData);
              } catch (err) {
                console.error(err);
              }
            }

            _context8.prev = 17;
            _context8.next = 20;
            return fetch("".concat(getBackendHost(window.location.host, window.location.protocol), "/backend/leads/request"), {
              method: "POST",
              headers: {
                'Content-Type': "application/json"
              },
              body: JSON.stringify(demoLeadData)
            }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
              return _regeneratorRuntime.wrap(function _callee6$(_context7) {
                while (1) {
                  switch (_context7.prev = _context7.next) {
                    case 0:
                      _context7.next = 2;
                      return track("Demo Requested", demoTrackingData, true);

                    case 2:
                      purgePIIFromLocalStorage();

                    case 3:
                    case "end":
                      return _context7.stop();
                  }
                }
              }, _callee6);
            })))["catch"](function (error) {
              console.error(error);
            });

          case 20:
            _context8.next = 25;
            break;

          case 22:
            _context8.prev = 22;
            _context8.t0 = _context8["catch"](17);
            console.error(_context8.t0);

          case 25:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee7, null, [[17, 22]]);
  }));

  return function createDemoLead(_x4) {
    return _ref7.apply(this, arguments);
  };
}();
/**
 * Progressive Profile form custom onSubmit logic.
 * Fires Progressive Profile request form track event.
 * @param {Object} formData
 * @param {String} additionalTrackEvent
 * @param {Object} options
 */

export var trackProgressiveProfileForm = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(formData) {
    var trackingData;
    return _regeneratorRuntime.wrap(function _callee8$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            // Set up the tracking payload.
            trackingData = {
              type: formData.customFormIdentifier ? formData.customFormIdentifier : "website",
              formId: formData.customFormIdentifier ? formData.customFormIdentifier : "demo-progressive-profiling",
              email: formData.email || "",
              jobTitle: formData.jobTitle,
              companySize: formData.companySize,
              monthlyTraffic: formData.monthlyTraffic,
              timeline: formData.timeline
            }; // Fire a 'Email Captured' event once form is successfully submitted.

            _context9.next = 3;
            return track("Progressive Profile Captured", trackingData);

          case 3:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee8);
  }));

  return function trackProgressiveProfileForm(_x5) {
    return _ref9.apply(this, arguments);
  };
}();
/**
 * Email Capture form custom onSubmit logic.
 * Fires Email Captured request form track event.
 * @param {Object} formData
 * @param {String} additionalTrackEvent
 * @param {Object} options
 */

export var trackEmailCaptureForm = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(formData, additionalTrackEvent, options) {
    var trackingData, _iterator, _step, trackEvt;

    return _regeneratorRuntime.wrap(function _callee9$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            // Set up the tracking payload.
            trackingData = _objectSpread({
              email: formData.email,
              type: formData.customFormIdentifier ? formData.customFormIdentifier : "",
              form: _objectSpread({
                id: formData.customFormIdentifier ? formData.customFormIdentifier : "",
                email: formData.email,
                jobTitle: formData.jobTitle
              }, options === null || options === void 0 ? void 0 : options.customFormData)
            }, options === null || options === void 0 ? void 0 : options.customTrackData); // Fire a 'Email Captured' event once form is successfully submitted.

            _context10.next = 3;
            return track("Email Captured", trackingData);

          case 3:
            if (!additionalTrackEvent) {
              _context10.next = 26;
              break;
            }

            if (!Array.isArray(additionalTrackEvent)) {
              _context10.next = 24;
              break;
            }

            _iterator = _createForOfIteratorHelper(additionalTrackEvent);
            _context10.prev = 6;

            _iterator.s();

          case 8:
            if ((_step = _iterator.n()).done) {
              _context10.next = 14;
              break;
            }

            trackEvt = _step.value;
            _context10.next = 12;
            return track(trackEvt, trackingData);

          case 12:
            _context10.next = 8;
            break;

          case 14:
            _context10.next = 19;
            break;

          case 16:
            _context10.prev = 16;
            _context10.t0 = _context10["catch"](6);

            _iterator.e(_context10.t0);

          case 19:
            _context10.prev = 19;

            _iterator.f();

            return _context10.finish(19);

          case 22:
            _context10.next = 26;
            break;

          case 24:
            _context10.next = 26;
            return track(additionalTrackEvent, trackingData);

          case 26:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee9, null, [[6, 16, 19, 22]]);
  }));

  return function trackEmailCaptureForm(_x6, _x7, _x8) {
    return _ref10.apply(this, arguments);
  };
}();
/**
 * Integration request form custom onSubmit logic.
 * Fires integration request form track event.
 * @param {Object} formData
 */

export var trackIntegrationRequestForm = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(formData) {
    var integrationRequestTrackingData;
    return _regeneratorRuntime.wrap(function _callee10$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            // Set up the tracking payload.
            integrationRequestTrackingData = {
              company: formData.company,
              email: formData.email,
              // eslint-disable-next-line camelcase
              tool_requested_name: formData.toolName,
              // eslint-disable-next-line camelcase
              tool_requested_type: formData.toolType,
              // eslint-disable-next-line camelcase
              use_case: formData.useCase
            }; // Fire a 'Tool Request Form Submitted' event once form is successfully submitted.

            _context11.next = 3;
            return track("Tool Request Form Submitted", integrationRequestTrackingData);

          case 3:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee10);
  }));

  return function trackIntegrationRequestForm(_x9) {
    return _ref11.apply(this, arguments);
  };
}();
/**
 * Program signup track info
 * It is being used by, Contact Dc, Get Access, and any other program signup
 * that requires programType on the event.
 * @param {FieldValues} formData
 */

export var trackProgramSignupForm = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(formData) {
    var formId, jobTitle, baseData, programSignupTrackingData;
    return _regeneratorRuntime.wrap(function _callee11$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            // Set up the tracking payload.
            formId = formData.customFormIdentifier;
            jobTitle = formData.companyJobTitle || formData.jobTitle;
            baseData = _objectSpread(_objectSpread(_objectSpread({
              email: formData.email,
              name: formData.name,
              firstName: formData.name.split(" ")[0],
              lastName: formData.name.split(" ").slice(1).join(" ") || "null"
            }, formId && {
              formId: formId
            }), jobTitle && {
              jobTitle: jobTitle
            }), {}, {
              programType: formId || ""
            }); // Remove duplicates from base data.

            delete formData.name;
            delete formData.email;
            delete formData.companyJobTitle;
            delete formData.jobTitle;
            delete formData.customFormIdentifier;
            programSignupTrackingData = _objectSpread(_objectSpread({}, baseData), formData);
            _context12.prev = 9;
            _context12.next = 12;
            return track("Program Signup", programSignupTrackingData);

          case 12:
            _context12.next = 14;
            return track("Email Captured", programSignupTrackingData, false, "client");

          case 14:
            _context12.next = 19;
            break;

          case 16:
            _context12.prev = 16;
            _context12.t0 = _context12["catch"](9);
            return _context12.abrupt("return", _context12.t0);

          case 19:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee11, null, [[9, 16]]);
  }));

  return function trackProgramSignupForm(_x10) {
    return _ref12.apply(this, arguments);
  };
}();
/**
 * Catalog search form tracking logic.
 * Fires Catalog Searched track event.
 * @param {String} query
 */

export var trackCatalogSearch = /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(query) {
    var catalogSearchPayload;
    return _regeneratorRuntime.wrap(function _callee12$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            catalogSearchPayload = {
              searchQuery: query
            };
            _context13.next = 3;
            return track("Catalog Searched", catalogSearchPayload, false, "client");

          case 3:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee12);
  }));

  return function trackCatalogSearch(_x11) {
    return _ref13.apply(this, arguments);
  };
}();
/**
 * CDP Week form custom onSubmit logic.
 * Submits lead request to `segment-site-backend`.
 * @param {Object} cdpWeekFormData
 */

export var createCdpWeekLead = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(cdpWeekFormData) {
    var utms, firstRawURL, gclid, clientId, cdpWeekBigMarkerData, cdpWeekLeadData, utmData;
    return _regeneratorRuntime.wrap(function _callee13$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            // Populate vars to add to payloads.
            utms = getCookie("seg_attr_utm");
            firstRawURL = getCookie("seg_first_url");
            gclid = getCookie("gclid"); // Get the google analytics client id if present.

            clientId = getClientIdFromGA(); // Set up the lead endpoint payload.

            cdpWeekBigMarkerData = {
              formFields: {
                firstName: cdpWeekFormData.name.split(" ")[0],
                lastName: cdpWeekFormData.name.split(" ").slice(1).join(" ") || "null",
                email: cdpWeekFormData.email,
                phone: cdpWeekFormData.phone,
                company: cdpWeekFormData.company
              }
            }; // Set up the lead endpoint payload.

            cdpWeekLeadData = {
              formid: "cdp-week-2022",
              // Marketo form identifier.
              formType: "registration",
              // Human-readable text that describes the Segment website form - relied upon downstream.
              formFields: {
                name: cdpWeekFormData.name,
                email: cdpWeekFormData.email,
                phone: cdpWeekFormData.phone,
                company: cdpWeekFormData.company,
                firstRawURL: firstRawURL,
                clientId: clientId,
                gclid: gclid
              }
            }; // If we have utm parameters, let's append them to the `cdpWeekBigMarkerData` payload.

            if (utms && utms.length) {
              try {
                utmData = JSON.parse(utms);
                cdpWeekBigMarkerData = _objectSpread(_objectSpread({}, cdpWeekBigMarkerData), utmData);
                cdpWeekLeadData = _objectSpread(_objectSpread({}, cdpWeekLeadData), utmData);
              } catch (err) {
                console.error(err);
              }
            }

            _context14.prev = 7;
            _context14.next = 10;
            return fetch("".concat(getBackendHost(window.location.host, window.location.protocol), "/backend/bigmarker/register"), {
              method: "POST",
              headers: {
                'Content-Type': "application/json"
              },
              body: JSON.stringify(cdpWeekBigMarkerData)
            }).then(function () {
              // Fire a 'Form Submit Success' event once form is successfully submitted.
              // Override consent is set to true because there is a disclaimer on this form.
              track("Form Submit Success", cdpWeekLeadData, true);
            }).then(function () {
              // Fire a 'CDP Week Registration Submitted' event once form is successfully submitted.
              // Override consent is set to true because there is a disclaimer on the form.
              track("CDP Week Registration Submitted", cdpWeekLeadData, true);
            })["catch"](function (error) {
              console.error(error);
            });

          case 10:
            _context14.next = 15;
            break;

          case 12:
            _context14.prev = 12;
            _context14.t0 = _context14["catch"](7);
            console.error(_context14.t0);

          case 15:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee13, null, [[7, 12]]);
  }));

  return function createCdpWeekLead(_x12) {
    return _ref14.apply(this, arguments);
  };
}();
/**
 * CDP Week 2023 form custom onSubmit logic.
 * Submits lead request to `segment-site-backend`.
 * @param {Object} cdpWeekFormData
 */

export var createCdpWeek2023Lead = /*#__PURE__*/function () {
  var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(cdpWeekFormData) {
    var utms, firstRawURL, gclid, clientId, cdpWeekBigMarkerData, cdpWeekLeadData, utmData;
    return _regeneratorRuntime.wrap(function _callee14$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            // Populate vars to add to payloads.
            utms = getCookie("seg_attr_utm");
            firstRawURL = getCookie("seg_first_url");
            gclid = getCookie("gclid"); // Get the google analytics client id if present.

            clientId = getClientIdFromGA(); // Set up the lead endpoint payload.

            cdpWeekBigMarkerData = {
              formFields: {
                firstName: cdpWeekFormData.name.split(" ")[0],
                lastName: cdpWeekFormData.name.split(" ").slice(1).join(" ") || "null",
                email: cdpWeekFormData.email,
                phone: cdpWeekFormData.phone,
                company: cdpWeekFormData.company,
                country: cdpWeekFormData.country
              }
            }; // Set up the lead endpoint payload.

            cdpWeekLeadData = {
              formid: cdpWeekFormData.customFormIdentifier,
              // Marketo form identifier.
              formType: cdpWeekFormData.customFormIdentifier,
              // Human-readable text that describes the Segment website form - relied upon downstream.
              formFields: {
                name: cdpWeekFormData.name,
                email: cdpWeekFormData.email,
                phone: cdpWeekFormData.phone,
                company: cdpWeekFormData.company,
                country: cdpWeekFormData.country,
                firstRawURL: firstRawURL,
                clientId: clientId,
                gclid: gclid
              }
            }; // If we have utm parameters, let's append them to the `cdpWeekBigMarkerData` payload.

            if (utms && utms.length) {
              try {
                utmData = JSON.parse(utms);
                cdpWeekBigMarkerData = _objectSpread(_objectSpread({}, cdpWeekBigMarkerData), utmData);
                cdpWeekLeadData = _objectSpread(_objectSpread({}, cdpWeekLeadData), utmData);
              } catch (err) {
                console.error(err);
              }
            }

            _context15.prev = 7;
            _context15.next = 10;
            return fetch("".concat(getBackendHost(window.location.host, window.location.protocol), "/backend/bigmarker/register"), {
              method: "POST",
              headers: {
                'Content-Type': "application/json"
              },
              body: JSON.stringify(cdpWeekBigMarkerData)
            }).then(function () {
              // Fire a 'Form Submit Success' event once form is successfully submitted.
              // Override consent is set to true because there is a disclaimer on this form.
              track("Form Submit Success", cdpWeekLeadData, true);
            }).then(function () {
              // Fire a 'CDP Week Registration Submitted' event once form is successfully submitted.
              // Override consent is set to true because there is a disclaimer on the form.
              track("CDP Week Registration Submitted", cdpWeekLeadData, true);
            })["catch"](function (error) {
              console.error(error);
            });

          case 10:
            _context15.next = 15;
            break;

          case 12:
            _context15.prev = 12;
            _context15.t0 = _context15["catch"](7);
            console.error(_context15.t0);

          case 15:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee14, null, [[7, 12]]);
  }));

  return function createCdpWeek2023Lead(_x13) {
    return _ref15.apply(this, arguments);
  };
}();
/**
 * Track validation errors on demo form.
 * @param errors
 */

export var trackValidationErrorDemoForm = function trackValidationErrorDemoForm(errors) {
  track("Demo Request Validation Failed", {
    formId: "1136",
    formType: "demo",
    formFields: {
      id: "1136",
      inputErrors: _objectSpread({}, Object.keys(errors).reduce(function (acc, key) {
        var _errors$key$ref;

        return _objectSpread(_objectSpread({}, acc), _defineProperty({}, key, (_errors$key$ref = errors[key].ref) === null || _errors$key$ref === void 0 ? void 0 : _errors$key$ref.value));
      }, {})),
      errorMessages: _objectSpread({}, Object.keys(errors).reduce(function (acc, key) {
        return _objectSpread(_objectSpread({}, acc), _defineProperty({}, key, errors[key].message));
      }, {}))
    }
  });
};
/**
 * Track signup errors on signup form.
 * @param data
 * @param message
 */

export var trackErrorSignupForm = function trackErrorSignupForm(data, message) {
  track("Workspace Signup Failure", {
    formId: "site-marketing-workspace",
    formType: "site-marketing-workspace",
    formFields: _objectSpread(_objectSpread({}, data), {}, {
      errorMessage: message
    })
  });
};
/**
 * Track server errors
 * @param data
 * @param formId
 * @param errorDetails
 */

export var trackServerError = function trackServerError(data, formId, errorDetails) {
  track("Error Message Returned", {
    properties: {
      error: "serverError",
      type: "400",
      errorDetails: errorDetails
    },
    formId: formId,
    formFields: _objectSpread({}, data)
  });
};
/**
 * Track validation errors on demo form.
 * @param errors
 */

export var trackValidationErrorProgressiveProfileForm = function trackValidationErrorProgressiveProfileForm(errors) {
  track("Progressive Profile Validation Failed", {
    formId: "demo-progressive-profiling",
    formType: "demo",
    formFields: {
      id: "demo-progressive-profiling",
      inputErrors: _objectSpread({}, Object.keys(errors).reduce(function (acc, key) {
        if (key === "jobTitle") {
          var _errors$key$ref2;

          return _objectSpread(_objectSpread({}, acc), _defineProperty({}, key, (_errors$key$ref2 = errors[key].ref) === null || _errors$key$ref2 === void 0 ? void 0 : _errors$key$ref2.value));
        } // The only errors dropdowns have are empty values.


        return _objectSpread(_objectSpread({}, acc), _defineProperty({}, key, ""));
      }, {}))
    }
  });
};

/**
 * Button click tracking.
 * Fires Button Clicked track event.
 * @param {String} additionalTrackEvent
 * @param {Object} options
 */
export var trackButtonClick = /*#__PURE__*/function () {
  var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(buttonData, additionalTrackEvent) {
    var buttonCampaign, queryString, queryStringObject, trackingData, clientSideTrack, _iterator2, _step2, trackEvt;

    return _regeneratorRuntime.wrap(function _callee15$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            // Populate query string vars to add to payloads.
            buttonCampaign = {};

            if (buttonData.targetUrl && buttonData.targetUrl.indexOf("?") !== -1) {
              queryString = buttonData.targetUrl.substring(buttonData.targetUrl.indexOf("?") + 1) || "";
              queryStringObject = JSON.parse("{\"" + queryString.replace(/&/g, "\",\"").replace(/=/g, "\":\"") + "\"}", function (key, value) {
                return key === "" ? value : decodeURIComponent(value);
              });

              if (queryString) {
                buttonCampaign = convertUtmToCampaign(JSON.stringify(queryStringObject));
              }
            } // Set up the tracking payload.


            trackingData = {
              // eslint-disable-next-line camelcase
              button_id: buttonData.buttonId ? buttonData.buttonId : "",
              // eslint-disable-next-line camelcase
              button_text: buttonData.buttonText,
              // eslint-disable-next-line camelcase
              target_url: buttonData.targetUrl ? buttonData.targetUrl : "",
              // eslint-disable-next-line camelcase
              button_campaign: buttonData.buttonCampaign || buttonCampaign || ""
            };

            clientSideTrack = function clientSideTrack(event) {
              return track(event, trackingData, false, "client");
            }; // Fire a 'Button Clicked' event once form is successfully submitted.


            _context16.next = 6;
            return clientSideTrack("Button Clicked");

          case 6:
            if (!additionalTrackEvent) {
              _context16.next = 29;
              break;
            }

            if (!Array.isArray(additionalTrackEvent)) {
              _context16.next = 27;
              break;
            }

            _iterator2 = _createForOfIteratorHelper(additionalTrackEvent);
            _context16.prev = 9;

            _iterator2.s();

          case 11:
            if ((_step2 = _iterator2.n()).done) {
              _context16.next = 17;
              break;
            }

            trackEvt = _step2.value;
            _context16.next = 15;
            return clientSideTrack(trackEvt);

          case 15:
            _context16.next = 11;
            break;

          case 17:
            _context16.next = 22;
            break;

          case 19:
            _context16.prev = 19;
            _context16.t0 = _context16["catch"](9);

            _iterator2.e(_context16.t0);

          case 22:
            _context16.prev = 22;

            _iterator2.f();

            return _context16.finish(22);

          case 25:
            _context16.next = 29;
            break;

          case 27:
            _context16.next = 29;
            return clientSideTrack(additionalTrackEvent);

          case 29:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee15, null, [[9, 19, 22, 25]]);
  }));

  return function trackButtonClick(_x14, _x15) {
    return _ref16.apply(this, arguments);
  };
}();
/**
 * Twilio Lead form custom onSubmit logic.
 * Submits client-side and server-side `Form Submit Success` events.
 * @param {Object} twilioLeadFormData
 */

export var trackTwilioLeadForm = /*#__PURE__*/function () {
  var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(twilioLeadFormData) {
    var firstRawURL, gclid, clientId, twilioLeadData;
    return _regeneratorRuntime.wrap(function _callee16$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            // Populate vars to add to payloads.
            firstRawURL = getCookie("seg_first_url");
            gclid = getCookie("gclid"); // Get the google analytics client id if present.

            clientId = getClientIdFromGA(); // Set up the lead endpoint payload.

            twilioLeadData = {
              formid: twilioLeadFormData.customFormIdentifier,
              // Marketo form identifier.
              formType: twilioLeadFormData.customFormIdentifier,
              // Human-readable text that describes the Segment website form - relied upon downstream.
              email: twilioLeadFormData.email,
              formFields: {
                firstName: twilioLeadFormData.firstName,
                lastName: twilioLeadFormData.lastName,
                email: twilioLeadFormData.email,
                company: twilioLeadFormData.companyName,
                phone: twilioLeadFormData.phoneNumber,
                aeDsrName: twilioLeadFormData.aeDsrName,
                aeDsrEmail: twilioLeadFormData.aeDsrEmail,
                currentTwilioCustomer: twilioLeadFormData.currentTwilioCustomer,
                marketingCampaignsLead: twilioLeadFormData.marketingCampaignsLead,
                twilioSpendLevel: twilioLeadFormData.twilioSpendLevel,
                detailsOfInterest: twilioLeadFormData.detailsOfInterest,
                detailsOfRelationship: twilioLeadFormData.detailsOfRelationship,
                firstRawURL: firstRawURL,
                clientId: clientId,
                gclid: gclid
              }
            };
            _context17.prev = 4;
            _context17.next = 7;
            return track("Form Submit Success", twilioLeadData, true, "both");

          case 7:
            _context17.next = 12;
            break;

          case 9:
            _context17.prev = 9;
            _context17.t0 = _context17["catch"](4);
            console.error(_context17.t0);

          case 12:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee16, null, [[4, 9]]);
  }));

  return function trackTwilioLeadForm(_x16) {
    return _ref17.apply(this, arguments);
  };
}();
/**
 * Catalog card click tracking.
 * @param catalogCardData
 */

export var trackCatalogCardClick = /*#__PURE__*/function () {
  var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(catalogCardData) {
    return _regeneratorRuntime.wrap(function _callee17$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            track("Catalog Card Clicked", catalogCardData);

          case 1:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee17);
  }));

  return function trackCatalogCardClick(_x17) {
    return _ref18.apply(this, arguments);
  };
}();